var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-floating-wrapper"},[_c('div',{staticClass:"container text-end"},[_c('router-link',{staticClass:"btn-add",attrs:{"to":"/transaction/sell/add"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }